// import { format } from "date-fns";

export function checkAuthenticated() {
  const authenticated = localStorage.getItem("authenticated");
  if (authenticated !== "true") {
    return {
      authenticated: false,
      sessionExpired: false,
    };
  }

  return {
    authenticated: true,
    sessionExpired: false,
  };

  // Check session hasn't expired
  // let tokenExpiry = null;
  // try {
  //   tokenExpiry = new Date(JSON.parse(localStorage.getItem('user')).tokenExpiry);

  //   if (!tokenExpiry || !format().isBefore(tokenExpiry)) {
  //     // Session has expired, not authenticated
  //     localStorage.setItem('authenticated', false);
  //     return {
  //       authenticated: false,
  //       sessionExpired: true
  //     };
  //   }
  //   // User is authenticated
  //   axios.defaults.headers.common['X-FH-Session-Token'] = localStorage.getItem('sessionID');

  //   return {
  //     authenticated: true,
  //     sessionExpired: false
  //   };
  // } catch (err) {
  //   console.log('Error getting tokenExpiry ', err);
  //   return {
  //     authenticated: false,
  //     sessionExpired: false
  //   };
  // }
}

export async function logout() {
  localStorage.clear();
  return true;
}

// eslint-disable-next-line consistent-return
export const getUser = () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  if (userData) {
    return userData;
    // eslint-disable-next-line no-else-return
  } else {
    logout();
    window.location.pathname = "/login";
  }
};
